const STORAGE_KEY = "pendingTestResults";
const TEN_MINUTES = 10 * 60 * 1000;

export const PENDING_TEST_RESULTS_EVENT = "pendingTestResultsChanged";

export function hasPendingTestResults() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (!saved) return false;

  try {
    const pending = JSON.parse(saved);
    const savedAt = pending.savedAt || 0;
    if (Date.now() - savedAt >= TEN_MINUTES) return false;

    const metrics = pending.metrics || pending;
    return !!(metrics?.desktop || metrics?.mobile);
  } catch {
    return false;
  }
}

export function notifyPendingTestResultsChanged() {
  window.dispatchEvent(new Event(PENDING_TEST_RESULTS_EVENT));
}
